import { useEffect, useState } from 'react';
import { recordVisitAndGetStats } from '../../api/visits';
import './VisitorCounter.css';

function formatCount(value) {
  return new Intl.NumberFormat().format(value);
}

const VISITOR_PERIODS = [
  { key: 'daily', label: 'Today', compactLabel: 'Today' },
  { key: 'weekly', label: 'This week', compactLabel: 'Week' },
  { key: 'monthly', label: 'This month', compactLabel: 'Month' },
];

function VisitorCounter({ compact = false }) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;

    recordVisitAndGetStats()
      .then((value) => {
        if (!cancelled) {
          setStats(value);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStats(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (stats == null) {
    return null;
  }

  return (
    <div
      className={`visitor-counter${compact ? ' visitor-counter--compact' : ''}`}
      role="status"
      aria-label="Visitor statistics"
    >
      {VISITOR_PERIODS.map(({ key, label, compactLabel }) => (
        <div key={key} className="visitor-counter__item">
          <span className="visitor-counter__value">{formatCount(stats[key])}</span>
          <span className="visitor-counter__label">
            {compact ? compactLabel : label}
          </span>
        </div>
      ))}
    </div>
  );
}

export default VisitorCounter;
